export const exerciseDraggablesSqlToObject = (draggables) => {
  if (!draggables) return null;

  const draggablesArray = [];

  draggables.forEach((draggable, index) => {
    draggablesArray.push({
      id: draggable.id,
      exerciseId: draggable.exerciseId,
      draggableId: draggable.draggableId,
      leftValue: draggable.leftValue,
      topValue: draggable.topValue,
      isFlipped: draggable.isFlipped,
      width: draggable.width,
      height: draggable.height,
      rotationAngle: draggable.rotationAngle,
      strokeThickness: null,
      fillColor: null,
      strokeColor: null,
      zindex: index,
    });
  });

  return draggablesArray;
}